import { File } from '../interfaces/File';
import { MappingInfo } from '../interfaces/Mapping';
import axios, { AxiosResponse } from 'axios';

export const BATCH_ASSETS_URL = '/api/v1/batch/assets';

interface AssetsResponse {
	data: string;
	status: number;
	success: boolean;
}

const getFormDataObject = (file: any) => {
	const formData = new FormData();
	formData.set('appName', 'S1 Batch');
	formData.append('file', file);
	return formData;
};

export const AssetsApi = {
	async uploadFile(file: File): Promise<AssetsResponse> {
		return axios({
			method: 'POST',
			url: BATCH_ASSETS_URL,
			data: getFormDataObject(file),
		})
			.then(response => {
				return response.data;
			})
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
	async deleteFile(fileId: string): Promise<void> {
		return axios.delete(`${BATCH_ASSETS_URL}/${fileId}`);
	},

	async getFile(fileId: string): Promise<AxiosResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_ASSETS_URL}/${fileId}`,
			headers: {
				Accept: 'application/zip, application/json',
			},
			responseType: 'blob',
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async getPreMapInfo(fileId: string = '', ruleType: string = ''): Promise<MappingInfo[]> {
		const preMapCompleteUrl = ruleType ? `/${ruleType}` : '';
		return axios
			.get(`${BATCH_ASSETS_URL}/${fileId}/premap${preMapCompleteUrl}`)
			.then(response => response.data.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
	async getPreviewRows(fileId: string, ruleType: string | undefined) {
		const previewRowsUrl = ruleType ? `/preview/${ruleType}` : '/preview';
		return axios
			.get(`${BATCH_ASSETS_URL}/${fileId}${previewRowsUrl}`)
			.then(response => response.data)
			.catch(err => {
				console.error(err);
				throw err;
			});
	},
};
